import { jsx as _jsx } from "react/jsx-runtime";
import { StyleSheet } from '@react-pdf/renderer';
import { usePDFContext } from './pdf.context';
const styles = StyleSheet.create({
    body: {
        paddingTop: 35,
        paddingBottom: 65,
        paddingHorizontal: 35,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between'
    }
});
export default function Document({ children }) {
    const { Document: BaseDocument, Page } = usePDFContext();
    return (_jsx(BaseDocument, { children: _jsx(Page, { style: styles.body, children: children }) }));
}
